import { inject, Injectable } from "@angular/core";
import { LiveSessionState } from "@pcp/core/interfaces";
import { Endpoint } from "@pcp/http";
import { Observable } from "rxjs";


/**
 * Gets and provides the PCP Live Session State.
 */
@Injectable({
    providedIn: 'root',
})
export class LiveSessionStateApiService {

    private readonly GET_STATE_URL = '/api/live-lesson/state';
    private readonly endpoint = inject(Endpoint);

    /**
     * Force fetch/request the live session state using the API or SignalR.
     */
    fetchLiveSessionState(): Observable<{ state: LiveSessionState }> {
        return this.endpoint.get<{ state: LiveSessionState }>(this.GET_STATE_URL);
    }
}
